import 'wave-ui/dist/wave-ui.css'
import './assets/theme.css'
import { createApp } from 'vue'
import App from './App.vue'
import WaveUI from 'wave-ui'

const app = createApp(App)

new WaveUI(app, {
  colors: {
    primary: '#FFB300',
    secondary: '#78909C',
    success: '#2E7D32',
    error: '#C62828',
    warning: '#D4760A',
    info: '#1565C0',
  }
})

requestAnimationFrame(() => {
  app.mount('#app')
})
